var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end my-1",
          attrs: { cols: "12" },
        },
        [
          _vm.HasPermission(_vm.PermissionList.Sales_Create)
            ? _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.show("add-complaint-modal")
                    },
                  },
                },
                [_vm._v(" Add Complaint ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c(
                "label",
                { staticClass: "d-inline-block text-sm-left mr-50" },
                [_vm._v("Per page")]
              ),
              _c("b-form-select", {
                staticClass: "w-50",
                attrs: {
                  id: "perPageSelect",
                  options: _vm.pageOptions.map(function (option) {
                    return { text: option, value: option }
                  }),
                  size: "sm",
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { md: "10" } },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                label: "Filter",
                "label-cols-sm": "8",
                "label-align-sm": "right",
                "label-size": "sm",
                "label-for": "filterInput",
              },
            },
            [
              _c(
                "b-input-group",
                { attrs: { size: "sm" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "filterInput",
                      type: "search",
                      placeholder: "Type to Search",
                    },
                    on: { input: _vm.onSearch },
                    model: {
                      value: _vm.searchQuery,
                      callback: function ($$v) {
                        _vm.searchQuery = $$v
                      },
                      expression: "searchQuery",
                    },
                  }),
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { disabled: !_vm.searchQuery },
                          on: {
                            click: function ($event) {
                              _vm.searchQuery = ""
                            },
                          },
                        },
                        [_vm._v(" Clear ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            {
              staticClass: "mb-3",
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            [
              _c("b-tab", { attrs: { title: "All", active: "" } }),
              _vm._l(_vm.statusOptions, function (option) {
                return _c("b-tab", {
                  key: option.value,
                  attrs: { title: option.text },
                })
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          !_vm.loadingCustomer
            ? _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  responsive: "",
                  items: _vm.filteredOpportunitiesByTab,
                  fields: _vm.fields,
                  "per-page": _vm.perPage,
                  "current-page": _vm.currentPage,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc,
                },
                on: {
                  "update:sortBy": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function ($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function ($event) {
                    _vm.sortDesc = $event
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(dueDate)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDate(data.item.dueDate)) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(openDate)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDate(data.item.openDate)) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(status)",
                      fn: function (data) {
                        return [
                          _c(
                            "b-badge",
                            {
                              attrs: {
                                variant: _vm.getBadgeVariant(data.item.status),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.beautifyStatus(data.item.status))
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(feedbacks)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getLatestFeedbackTitle(data.item.feedbacks)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(actions)",
                      fn: function (data) {
                        return [
                          _c(
                            "b-dropdown",
                            {
                              attrs: {
                                variant: "link",
                                "toggle-class": "text-decoration-none",
                                "no-caret": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "button-content",
                                    fn: function () {
                                      return [
                                        _c("feather-icon", {
                                          staticClass:
                                            "text-body align-middle mr-25",
                                          attrs: {
                                            icon: "MoreVerticalIcon",
                                            size: "16",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm.HasPermission(_vm.PermissionList.Sales_View)
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        to: _vm.viewComplaint(data.item.id),
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "EyeIcon" },
                                      }),
                                      _c("span", [_vm._v("View")]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              ["Resolved", "NotResolved"].includes(
                                data.item.status
                              ) || !_vm.isEdit
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "dropdown-item",
                                      staticStyle: {
                                        color: "#6c757d",
                                        "pointer-events": "none",
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "RotateCcwIcon" },
                                      }),
                                      _c("span", [_vm._v("Change Status")]),
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.promptChangeStatus(
                                            data.item
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "RotateCcwIcon" },
                                      }),
                                      _c("span", [_vm._v("Change Status")]),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  927295256
                ),
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.loadingCustomer
                ? _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning", block: "" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-pagination", {
                staticClass: "my-0",
                attrs: {
                  "total-rows": _vm.rows,
                  "per-page": _vm.perPage,
                  align: "center",
                  size: "sm",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "change-status-modal",
            title: "Change Complaint Status",
          },
          on: {
            ok: _vm.changeStatus,
            cancel: _vm.onModalCancel,
            close: _vm.onModalCancel,
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function (ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: { click: _vm.onModalCancel },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        disabled: _vm.isStatusChangeDisabled,
                        variant: "primary",
                      },
                      on: { click: ok },
                    },
                    [_vm._v("Change Status")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                label: "Select New Status:",
                "label-for": "status-select",
              },
            },
            [
              _c("b-form-select", {
                attrs: { id: "status-select", options: _vm.statusOptions },
                model: {
                  value: _vm.selectedStatus,
                  callback: function ($$v) {
                    _vm.selectedStatus = $$v
                  },
                  expression: "selectedStatus",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "add-complaint-modal", title: "Add Complaints" },
          on: {
            ok: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            },
            hidden: _vm.resetForm,
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function (ref) {
                var ok = ref.ok
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", disabled: _vm.submitting },
                      on: { click: _vm.onSubmit },
                    },
                    [
                      _vm.submitting
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v(
                        " " + _vm._s(_vm.submitting ? "Adding..." : "Add") + " "
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mx-auto", attrs: { cols: "12" } },
                [
                  _c(
                    "b-card",
                    { staticClass: "mb-3", attrs: { title: "Add Complaint" } },
                    [
                      _c("validation-observer", {
                        ref: "AddForm",
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var invalid = ref.invalid
                              return [
                                _c(
                                  "b-form",
                                  {
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onSubmit($event)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Customer:",
                                          "label-for": "Customer",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getLeadName(_vm.id)) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Assigned To:",
                                          "label-for": "Assigned",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Assigned To",
                                            vid: "Assigned To",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        options:
                                                          _vm.optionsSalesPerson,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .salespersonId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "salespersonId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.salespersonId",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Feedback Title:",
                                          "label-for": "Title",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Feedback Title",
                                            vid: "Feedback Title",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "Title",
                                                        type: "text",
                                                        required: "",
                                                        placeholder:
                                                          "Enter Feedback Title",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.feedback
                                                            .title,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form.feedback,
                                                            "title",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.feedback.title",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Feedback Description:",
                                          "label-for": "Description",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Feedback Description",
                                            vid: "Feedback Description",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-textarea", {
                                                      attrs: {
                                                        id: "textarea-default",
                                                        placeholder:
                                                          "Description",
                                                        rows: "3",
                                                        required: "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.feedback
                                                            .description,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form.feedback,
                                                            "description",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.feedback.description",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Status:",
                                          "label-for": "status-select",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Status",
                                            vid: "Status",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        id: "status-select",
                                                        options:
                                                          _vm.statusOptions,
                                                        required: "",
                                                      },
                                                      model: {
                                                        value: _vm.form.status,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "status",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.status",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Priority:",
                                          "label-for": "priority-select",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Priority",
                                            vid: "Priority",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        id: "priority-select",
                                                        options:
                                                          _vm.priorityOptions,
                                                        required: "",
                                                      },
                                                      model: {
                                                        value: _vm.form.rating,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "rating",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.rating",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: "Open Date",
                                                  "label-for": "creationDate",
                                                },
                                              },
                                              [
                                                _c("b-form-datepicker", {
                                                  staticClass: "mb-1",
                                                  attrs: {
                                                    id: "creationDate",
                                                    disabled: "",
                                                  },
                                                  model: {
                                                    value: _vm.creationDate,
                                                    callback: function ($$v) {
                                                      _vm.creationDate = $$v
                                                    },
                                                    expression: "creationDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: "Due Date",
                                                  "label-for": "dueDate",
                                                },
                                              },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    name: "Due Date",
                                                    vid: "Due Date",
                                                    rules: "required",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c(
                                                              "b-form-datepicker",
                                                              {
                                                                attrs: {
                                                                  id: "dueDate",
                                                                  min: _vm.minDate,
                                                                  config:
                                                                    _vm
                                                                      .configDue
                                                                      .wrap,
                                                                  required: "",
                                                                  placeholder:
                                                                    "Select a Due Date",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.form
                                                                      .dueDate,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.form,
                                                                        "dueDate",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "form.dueDate",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "edit-complaint-modal", title: "Edit Opportunity" },
          on: {
            ok: function ($event) {
              $event.preventDefault()
              return _vm.updateOpportunity($event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function (ref) {
                var ok = ref.ok
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", disabled: _vm.submitting },
                      on: { click: _vm.updateOpportunity },
                    },
                    [
                      _vm.submitting
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v(
                        " " +
                          _vm._s(_vm.submitting ? "Editing..." : "Edit") +
                          " "
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mx-auto", attrs: { cols: "12" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "mb-3",
                      attrs: { title: "Edit Opportunity" },
                    },
                    [
                      _c("validation-observer", {
                        ref: "EditForm",
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var invalid = ref.invalid
                              return [
                                _c(
                                  "b-form",
                                  {
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return _vm.updateOpportunity($event)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Customer:",
                                          "label-for": "Customer",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Customer/Lead",
                                            vid: "Customer/Lead",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        options:
                                                          _vm.optionsCustomer,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.editFormData
                                                            .leadClientId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.editFormData,
                                                            "leadClientId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "editFormData.leadClientId",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Opportunity Name:",
                                          "label-for": "name",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Opportunity Name",
                                            vid: "Opportunity Name",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "name",
                                                        type: "text",
                                                        required: "",
                                                        placeholder:
                                                          "Enter Opportunity Name",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.editFormData.name,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.editFormData,
                                                            "name",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "editFormData.name",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Status:",
                                          "label-for": "status-select",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Status",
                                            vid: "Status",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        id: "status-select",
                                                        options:
                                                          _vm.statusOptions,
                                                        required: "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.editFormData
                                                            .status,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.editFormData,
                                                            "status",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "editFormData.status",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Priority:",
                                          "label-for": "priority-select",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Priority",
                                            vid: "Priority",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        id: "priority-select",
                                                        options:
                                                          _vm.statusOptions,
                                                        required: "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.editFormData
                                                            .priority,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.editFormData,
                                                            "priority",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "editFormData.priority",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Expected Close Date:",
                                          "label-for": "expected-close-date",
                                        },
                                      },
                                      [
                                        _c("b-form-datepicker", {
                                          attrs: {
                                            id: "expected-close-date",
                                            required: "",
                                            placeholder: "Select a date",
                                          },
                                          model: {
                                            value:
                                              _vm.editFormData
                                                .expectedCloseDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.editFormData,
                                                "expectedCloseDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "editFormData.expectedCloseDate",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Description:",
                                          "label-for": "Description",
                                        },
                                      },
                                      [
                                        _c("b-form-textarea", {
                                          attrs: {
                                            id: "textarea-default",
                                            placeholder: "Description",
                                            rows: "3",
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.editFormData.description,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.editFormData,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "editFormData.description",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }